import { SomaParagraph, SomaCheckbox } from '@soma/react';
import styled from 'styled-components';

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  &::first-child {
    margin-top: 10px;
  }
  margin: 0 10px;
  margin-bottom: 10px;
`;

export const ItemTitle = styled(SomaParagraph)`
  color: rgb(230, 231, 231);
  margin-bottom: 12px;
  font-size: 14px;
  margin-top: 0px;
`;

export const CustomCheckbox = styled(SomaCheckbox)`
  zoom: 0.7;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
